module.exports = __webpack_public_path__ + "static/img/ali.5c4ed2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/ali.png
// module id = jKTT
// module chunks = 1